<template>
    <app>
        <app-header></app-header>
        <app-body>
            <slot />
        </app-body>
        <app-footer></app-footer>
    </app>
</template>

<script>
export default {
    name: 'DefaultLayout',
};
</script>
